<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div align="center" v-if="loader">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <b-container v-if="!loader" fluid>
        <b-row>
            <b-col><strong>Nombre del plan: </strong>{{plan.datosPlan.nombre}}</b-col>
            <b-col v-if="plan.nombreVale != null"><strong>Nombre del Vale: </strong>{{plan.nombreVale}}</b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col><p><strong>Cobertura: </strong> {{plan.datosPlan.cobertura.descripcion}}</p></b-col>
            <b-col v-if="plan.saldoVale != null"><p><strong>Monto del vale: </strong> {{plan.saldoVale}}</p></b-col>
        </b-row>
        <b-row>
            <b-col class="text-left">
                <p><strong>Tipo de plan: </strong>{{plan.datosPlan.tipo.nombreTipoPlan}}</p>
              <p><strong>Descripción: </strong>
                <span v-if="plan.datosPlan.descripcion.includes('<p>')" v-html="plan.datosPlan.descripcion"></span>
                <span v-else >{{plan.datosPlan.descripcion}}</span>
              </p>
                <p><strong>Requisitos: </strong>{{plan.datosPlan.requisitos}}</p>
                <p><strong>Fecha inicio: </strong>{{plan.datosPlan.fechaInicio | formatoFecha}}</p>
                <p><strong>Fecha fin: </strong>{{plan.datosPlan.fechaFin | formatoFecha}}</p>
                <p><strong>Responsable : </strong>{{plan.datosPlan.responsable.empleado}}</p>
                <p><strong>Portal en linea: {{plan.datosPlan.portalLinea ? 'Si': 'No'}}</strong></p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p><strong>Leyenda: </strong>{{plan.catacteristicas.leyenda}}</p>
            </b-col>
        </b-row>
        <b-row v-if="plan.parentescos.length > 0">
            <b-col class="text-left">
                <h5>Parentescos</h5>
                 <ul>
                     <li v-for="(item, index) in plan.parentescos" :key="item+index">{{item}}</li>
                 </ul>
            </b-col>
        </b-row>
        <b-row v-if="plan.clinicas.length > 0">
            <b-col class="text-left">
                <h5>Clínicas</h5>
                 <ul>
                     <li v-for="(item, index) in plan.clinicas" :key="item+index">{{item}}</li>
                 </ul>
            </b-col>
        </b-row>
        <b-row v-if="plan.tratamientos.length > 0">
            <b-col class="text-left">
                <h5>Tratamientos</h5>
                 <ul>
                     <li v-for="(item, index) in plan.tratamientos" :key="item+index">{{item}}</li>
                 </ul>
            </b-col>
        </b-row>
      <b-row v-if="plan.grupos.length > 0">
            <b-col class="text-left">
                <h5>Grupos</h5>
                 <ul>
                     <li v-for="(item, index) in plan.grupos" :key="item+index">{{item}}</li>
                 </ul>
            </b-col>
        </b-row>

    </b-container>
</div>
</template>

<script>
    export default {
        name: "detallePlan",
        props: ['id'],
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

              plan: null,
              loader: false
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
          this.obtenerDatosPlan()
        },
        methods:{
            obtenerDatosPlan(){
                this.loader = true;
                const parametros = {idPlan: this.id}
                this.$http.post(this.$api + 'planConvenio/obtenerDetalle', parametros).then(respuesta => {
                        if (respuesta.data.data) {
                            this.plan = respuesta.data.data;
                        }
                    }
                ).finally(()=>{
                    this.loader = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
